const autoFixFontSizeHandler = (textRef, avatarRef) => {
  if (textRef.current) {
    const textWidth = textRef.current.clientWidth;
    const sizeValue = avatarRef.current.offsetWidth;
    const scale = sizeValue / (textWidth + 20);
    if (sizeValue && scale < 1) {
      textRef.current.style.transform = `scale(${scale})`;
    }
  }
};

export { autoFixFontSizeHandler };
